import {
  GET_ATTRIBUTES,
  CREATE_ATTRIBUTE,
  UPDATE_ATTRIBUTE,
  SUCCESS,
  FAIL,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  isSubmitting: false,
  attributes: [],
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_ATTRIBUTES:
      return { ...state, isLoading: true };
    case `${GET_ATTRIBUTES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        attributes: [...payload],
      };
    case `${GET_ATTRIBUTES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case CREATE_ATTRIBUTE:
      return { ...state, isSubmitting: true };
    case `${CREATE_ATTRIBUTE}_${SUCCESS}`:
      return {
        ...state,
        isSubmitting: false,
        attributes: [...state.attributes, payload],
      };
    case `${CREATE_ATTRIBUTE}_${FAIL}`:
      return { ...state, isSubmitting: false, error: { ...payload } };

    case UPDATE_ATTRIBUTE:
      return { ...state, isSubmitting: true };
    case `${UPDATE_ATTRIBUTE}_${SUCCESS}`:
      return {
        ...state,
        isSubmitting: false,
        attributes: state.attributes.map((attr) => (attr.id === payload.id ? payload : attr)),
      };
    case `${UPDATE_ATTRIBUTE}_${FAIL}`:
      return { ...state, isSubmitting: false, error: { ...payload } };

    default:
      return state;
  }
};

